import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import itemTypes from 'helpers/enums/dropdownIcon/itemTypes'
import DropdownIcon from 'components/dropdown/dropdownIcon'
import creationMenuItemTypes from 'helpers/enums/creationMenuItemTypes'
import dropdownIconThemeTypes from 'helpers/enums/dropdownIconThemeTypes'
import CreationMenuContent from './creation_menu_content'

import styles from './creation_menu.scss'

import nearpodSlidesIcon from 'assets/components/creation_menu/nearpod-slides-icon.svg'
import nearpodVideoIcon from 'assets/components/creation_menu/nearpod-video-icon.svg'
import googleSlidesIcon from 'assets/components/creation_menu/google-slides-icon.svg'

const CreateMenuSlidesIcon = <Isvg src={nearpodSlidesIcon} cacheGetRequests={true} />
const CreateMenuVideoIcon = <Isvg src={nearpodVideoIcon} cacheGetRequests={true} />
const CreateMenuGoogleSlidesIcon = <Isvg src={googleSlidesIcon} cacheGetRequests={true} />
const FolderIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12"><defs><path id="folder-a" d="M6.5 1.7L4.839.132A.485.485 0 004.508 0H.573C.302 0 0 .143 0 .425V10.96c0 .281.302.595.574.595h14.424c.271 0 .41-.314.41-.595V2.124c0-.281-.139-.425-.41-.425H6.5z"/><path id="folder-c" d="M5.215 3.178H3.178v2.037H2.51V3.178H.474V2.51H2.51V.474h.668V2.51h2.037z"/></defs><g fill="none" fillRule="evenodd"><mask id="folder-b" fill="#fff"><use xlinkHref="#folder-a"/></mask><use fill="#5FD598" xlinkHref="#folder-a"/><g mask="url(#folder-b)"><g transform="translate(5.333 3.556)"><mask id="folder-d" fill="#fff"><use xlinkHref="#folder-c"/></mask><use fill="#FFF" xlinkHref="#folder-c"/><g mask="url(#folder-d)"><path fill="#FFF" d="M0 0h5.689v5.689H0z"/></g></g></g></g></svg>
const LessonsIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><g fill="none" fillRule="evenodd"><path fill="#00A8FF" d="M0 8c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8z"/><path fill="#FFF" d="M13.192 6.022l-2.758 5.756c-.015.03-.031.061-.05.091l-.02.044c-.225.456-.655.714-1.278.714H5.65c-.207 0-.36-.054-.458-.133a.387.387 0 01-.147-.312c0-.08.02-.172.067-.273h1.045c.01.001.017.006.026.006h2.924c.225-.002.403-.04.589-.397l.13-.271 2.503-5.225h.863zm-1.53-.032l-2.15 4.487a.919.919 0 01-.049.092l-.021.044c-.225.455-.655.714-1.277.714H3.119c-.207 0-.36-.055-.458-.134a.386.386 0 01-.147-.312c0-.08.02-.172.067-.273h1.045c.009.003.017.008.026.008H8.14c.247 0 .437-.018.635-.399l.13-.27 1.31-2.733.01-.023.143-.298V6.89l.431-.9h.865zm1.16-1.402c.206 0 .36.054.457.132.097.08.146.18.147.312 0 .078-.02.168-.064.267h-5.47c-.286 0-.464.064-.645.363L5.68 8.93l-.502 1.026h-.853L6.554 5.3c.225-.455.654-.713 1.277-.713zm-2.588-1.236c.207 0 .36.054.458.133.096.08.145.18.146.312 0 .078-.02.168-.063.266H6.822c-.247 0-.437.017-.634.399l-.13.27-2.49 5.2h-.864l2.496-5.2.32-.666c.224-.456.655-.714 1.277-.714z"/></g></svg>
const GoogleSlidesIcon = <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16"><defs><radialGradient id="google-slides-d" cx="3.172%" cy="2.716%" r="161.25%" fx="3.172%" fy="2.716%" gradientTransform="matrix(1 0 0 .72727 0 .007)"><stop offset="0%" stopColor="#FFF" stopOpacity=".1"/><stop offset="17%" stopColor="#FFF" stopOpacity=".07"/><stop offset="61%" stopColor="#FFF" stopOpacity=".02"/><stop offset="100%" stopColor="#FFF" stopOpacity="0"/></radialGradient><linearGradient id="google-slides-a" x1="50%" x2="50%" y1="8.609%" y2="100.022%"><stop offset="0%" stopColor="#BF360C" stopOpacity=".2"/><stop offset="28%" stopColor="#BF360C" stopOpacity=".12"/><stop offset="67%" stopColor="#BF360C" stopOpacity=".05"/><stop offset="100%" stopColor="#BF360C" stopOpacity=".02"/></linearGradient><filter id="google-slides-b" width="321.8%" height="309.5%" x="-110.9%" y="-52.4%" filterUnits="objectBoundingBox"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1"/><feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.434499547 0 0 0 0 0.40674059 0 0 0 0 0.39980085 0 0 0 0.2 0"/></filter><path id="google-slides-c" d="M7.273.364L10.88 4.18H8.273a1 1 0 01-1-1V.364z"/></defs><g fill="none" fillRule="evenodd"><g transform="translate(0 .364)"><path fill="#F4B400" fillRule="nonzero" d="M6.667.303H1a1 1 0 00-1 1V13.97a1 1 0 001 1h8.667a1 1 0 001-1V4.303L8.333 2.636 6.667.303z"/><path fill="#F1F1F1" fillRule="nonzero" d="M7.5 6.97H3.167a.5.5 0 00-.5.5v4.333a.5.5 0 00.5.5H7.5a.5.5 0 00.5-.5V7.47a.5.5 0 00-.5-.5zm-.167 3.833h-4V8.47h4v2.333z"/><path fill="url(#google-slides-a)" fillRule="nonzero" d="M6.96 4.01l3.707 3.707V4.303z"/><use fill="#000" filter="url(#google-slides-b)" xlinkHref="#google-slides-c"/><path fill="#FADA80" fillRule="nonzero" d="M6.667.303v3a1 1 0 001 1h3l-4-4z"/><path fill="#FFF" fillOpacity=".1" fillRule="nonzero" d="M6.667.303v.083l3.916 3.917h.084z"/><path fill="#FFF" fillOpacity=".2" fillRule="nonzero" d="M1 .303a1 1 0 00-1 1v.083a1 1 0 011-1h5.667V.303H1z"/><path fill="#BF360C" fillOpacity=".2" fillRule="nonzero" d="M9.667 14.886H1a1 1 0 01-1-1v.084a1 1 0 001 1h8.667a1 1 0 001-1v-.084a1 1 0 01-1 1z"/><path fill="#BF360C" fillOpacity=".1" fillRule="nonzero" d="M7.667 4.303a1 1 0 01-1-1v.083a1 1 0 001 1h3v-.083h-3z"/></g><path fill="url(#google-slides-d)" fillRule="nonzero" d="M6.667.667H1a1 1 0 00-1 1v12.666a1 1 0 001 1h8.667a1 1 0 001-1V4.667l-4-4z"/><path d="M0 0h10.667v16H0z"/></g></svg>
const InteractiveVideoIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><defs><path id="video-a" d="M10.471 10.491l4.862 1.762-1.412.885 1.991 1.986-.397.399-.398.397-1.99-1.986-.837 1.371-1.819-4.814zM6.461.08a6.374 6.374 0 015.983 8.555 2.7 2.7 0 00-3.809 3.809A6.373 6.373 0 116.46.08zm4.48 8.506a2.03 2.03 0 011.577 1.46.314.314 0 01-.074.317.318.318 0 01-.538-.151 1.397 1.397 0 10-1.657 1.735.317.317 0 01-.14.616 2.034 2.034 0 01-1.173-3.206 2.03 2.03 0 012.005-.771zM5.41 4.016a.338.338 0 00-.346-.01.34.34 0 00-.178.296l-.035 4.299a.343.343 0 00.518.296l3.505-2.121a.338.338 0 00.168-.29.345.345 0 00-.16-.292z"/></defs><g fill="none" fillRule="evenodd"><mask id="video-b" fill="#fff"><use xlinkHref="#video-a"/></mask><use fill="#FFF" fillRule="nonzero" xlinkHref="#video-a"/><g fill="#00A8FF" mask="url(#video-b)"><path d="M0 0h16v16H0z"/></g></g></svg>

const optionsMap = [
	{
		id: creationMenuItemTypes.LESSON,
		text: localize('create_lesson_inNearpod'),
		icon: LessonsIcon,
		type: itemTypes.BUTTON,
	},
	{
		id: creationMenuItemTypes.GOOGLE_SLIDE,
		text: localize('create_lesson_inGoogleSlides'),
		icon: GoogleSlidesIcon,
		type: itemTypes.BUTTON,
	},
	{
		id: creationMenuItemTypes.INTERACTIVE_VIDEO,
		text: localize('add_dropdown_interactiveVideo_new'),
		icon: InteractiveVideoIcon,
		type: itemTypes.BUTTON,
		beta: true,
	},
]

class CreationMenu extends PureComponent {

	getOptions = () => {
		let options
		if (this.props.shouldUpdateCreateLesson) {
			options = [
				{
					id: creationMenuItemTypes.LESSON,
					icon: CreateMenuSlidesIcon,
					component: this.buildContent(
						localize('create_menu_slides_title_2'),
						localize('create_menu_slides_description')
					),
				},
				{
					id: creationMenuItemTypes.INTERACTIVE_VIDEO,
					icon: CreateMenuVideoIcon,
					component: this.buildContent(
						localize('create_menu_videos_title'),
						localize('create_menu_videos_description')
					),
				},
				{
					id: `${creationMenuItemTypes.GOOGLE_SLIDE}_separator`,
					type: itemTypes.SEPARATOR,
				},
				{
					id: creationMenuItemTypes.GOOGLE_SLIDE,
					icon: CreateMenuGoogleSlidesIcon,
					component: this.buildContent(
						localize('create_menu_google_slides_title'),
						localize('create_menu_google_slides_description'),
					),
				},
			].filter(
				option => option.id !== creationMenuItemTypes.interactive_video || this.props.canCreateInteractiveVideo)
		} else {
			options = optionsMap.filter(
				option => option.id !== creationMenuItemTypes.interactive_video || this.props.canCreateInteractiveVideo)
			if (this.props.shouldShowFolderDropdownOption) {
				options.push(
					{
						id: `${creationMenuItemTypes.FOLDER}_separator`,
						type: itemTypes.SEPARATOR,
					},
					{
						id: creationMenuItemTypes.FOLDER,
						text: localize('global_folder'),
						icon: FolderIcon,
						type: itemTypes.BUTTON,
					}
				)
			}
		}
		return options
	}

	buildContent = (title, description, isBeta) => (
		<CreationMenuContent
			title={title}
			description={description}
			isBeta={isBeta}
		/>
	)

	render() {
		const theme = this.props.shouldUpdateCreateLesson
			? dropdownIconThemeTypes.BIGGER_ICONS
			: dropdownIconThemeTypes.SMALL_ICONS

		return (
			<div styleName='wrapper'>
				<DropdownIcon
					key_name='id'
					size='double'
					theme={theme}
					options={this.getOptions()}
					onElementClick={this.props.onSelect}
				/>
			</div>
		)
	}
}

CreationMenu.propTypes = {
	onSelect: PropTypes.func,
	canCreateInteractiveVideo: PropTypes.bool,
	shouldShowFolderDropdownOption: PropTypes.bool,
	shouldUpdateCreateLesson: PropTypes.bool,
}

CreationMenu.defaultProps = {
	onSelect: () => {},
	canCreateInteractiveVideo: false,
	shouldShowFolderDropdownOption: false,
	shouldUpdateCreateLesson: false,
}

export default CSSModules(CreationMenu, styles, {allowMultiple: true})
